// extracted by mini-css-extract-plugin
export default {"saveButton":"createSportForm_saveButton__OxIM5","select":"createSportForm_select__yPMAy"};